import { InformacionBusquedaUsuario, SelectCombo } from 'components/Types/GeneralTypes'
import FindAsyncSelect from 'components/Varios/SelectsComponent/FindAsyncSelect'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { FormGroup } from 'react-bootstrap'
import { Container, Row, Col, Form, Input, Label, Button } from "reactstrap"
import { BuscarInformacionPersonaByIdentificacion, BuscarInformacionPersonaByNombreApellido, ObtenerInformacionServidorHE } from './FunctionsProyeccionDirectivoUnidad'
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import ModalCargando from 'components/Varios/ModalCargando'
import TableServidoresPlanHE from '../PlanificacionHE/TableServidoresPlanHE'
import { DetalleServidoresProyHEDTO, InformacionServidoresOtrasUnidadesHEDTO } from './TypesProyeccionDirectivo'
import { DetalleParametrosProyeccionHE } from 'components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras'
import { DetalleGrupoActividadHEDTO, NovedadesServidoresHEDTO, ParamsHorasMesPlanificacionHEDTO } from '../PlanificacionHE/TypesPlanificacionHE'
import { ChangeToPromise } from 'functions/GeneralFunctions'

type PropsTabOtrasUnidades = {
    idUnidadAprueba: number,
    nombreUnidadAprueba: string,
    parametrosHorasRegimenProyeccion: DetalleParametrosProyeccionHE
    novedadesServidores: NovedadesServidoresHEDTO[]
    mensajeNovedad: string,
    estadoProyeccion: string,
    listadoServidoresOtrasUnidades: DetalleServidoresProyHEDTO[],
    recargarInformacion: () => Promise<void>
    gruposActividad: DetalleGrupoActividadHEDTO[];

    puedeRealizarAccion?: boolean
    guardarParcial: () => void
    enviarTh: () => void
    solicitarReverso: () => void
    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;

    mostrarReporteResumenProyPlanifExcel?: boolean
    loadingAccionReporteExcel?: boolean
    descargarResumenExcel?: () => Promise<void>
}

export default function TabOtrasUnidades(props: PropsTabOtrasUnidades) {

    const [identificacion, setidentificacion] = useState<string>("")
    const [nombresSeleccionado, setnombresSeleccionado] = useState<SelectCombo | undefined | null>()
    const [loadingidentificacion, setloadingidentificacion] = useState<boolean>(false)
    const [informacionTabla, setinformacionTabla] = useState<DetalleServidoresProyHEDTO[]>(props.listadoServidoresOtrasUnidades)
    const [buscandoinfoservidorhe, setbuscandoinfoservidorhe] = useState<boolean>(false)

    const realizarAcciones: boolean = (props.puedeRealizarAccion !== undefined && props.puedeRealizarAccion === true) || (props.puedeRealizarAccion === undefined)

    useEffect(() => {
        setinformacionTabla(props.listadoServidoresOtrasUnidades)
    }, [props.listadoServidoresOtrasUnidades])




    const validateCedula = (cedula) => {
        const cedulaRegex = new RegExp('^[0-9]{10}$');
        return cedulaRegex.test(cedula);
    };

    function MapearInformacionUsuario(info: InformacionBusquedaUsuario) {
        const informacionMapeada: SelectCombo = {

            label: info.apellidos + " " + info.nombres,
            value: info.idpersona.toString() + "|" + info.identificacion + "|" + info.apellidos + "|" + info.nombres
        }
        return informacionMapeada
    }

    async function ObtenerInformacionByCedula(identificacion: string) {
        if (identificacion.length === 10) {
            setidentificacion(identificacion)
            setloadingidentificacion(true)
            const respuesta = await BuscarInformacionPersonaByIdentificacion(identificacion)
            if (respuesta.status === 200 && respuesta.dataResponse) {

                const v = respuesta.dataResponse;
                const informacionMapeada: SelectCombo = MapearInformacionUsuario(v);
                setnombresSeleccionado(informacionMapeada);
            }
            else {
                showAlert("No se ha encontrado información con la identificación indicada", false);
            }
            setloadingidentificacion(false)
        }
        else if (identificacion.length < 10 && identificacion.length >= 0) {
            setidentificacion(identificacion)
        }
        else {
            showAlert("Solo puede ingresar 10 dígitos", false);
        }
    }

    async function ObtenerInformacionByNombreApellido(nombreapellido: string) {
        const respuesta = await BuscarInformacionPersonaByNombreApellido(nombreapellido)
        if (respuesta.status === 200 && respuesta.dataResponse && respuesta.dataResponse.length > 0) {
            const informacionMapeada: SelectCombo[] = respuesta.dataResponse.map((v, i) => {
                return MapearInformacionUsuario(v)
            })
            return informacionMapeada
        }
        else if (respuesta.status === 204) {
            return []//undefined;
        }
        else {
            return []//undefined;
        }


    }

    async function Pruebita() {
        const respuesta = await BuscarInformacionPersonaByNombreApellido("sss")
    }

    function OnChangeSelectApellidoNombre(seleccionado: SelectCombo | undefined) {
        if (seleccionado) {
            const informacionDivision = seleccionado?.value.split("|")
            const idpersona: number = +informacionDivision[0]
            const identific: string = informacionDivision[1]

            setidentificacion(identific)
            setnombresSeleccionado(seleccionado)
        }
        else {
            setnombresSeleccionado(seleccionado)
        }

    }

    // function CrearInformacionParaTabla(informacionServidor: InformacionServidoresOtrasUnidadesHEDTO) {
    //     const nuevoRegistroTabla: DetalleServidoresProyHEDTO = {
    //         idheproypersona: 0,
    //         idheproyunidadanio: 0,
    //         idpersona: informacionServidor.idpersona,
    //         nombrescompletos: informacionServidor.nombrescompletos,
    //         numactividades: 0,
    //         identificacion: informacionServidor.identificacion,
    //         cargo: informacionServidor.cargo,
    //         estado: "",
    //         rmu: informacionServidor.rmu,
    //         contador: 1,
    //         estadoproyeccion: "",
    //         tipo: informacionServidor.tipo,
    //         idregimenlaboral: informacionServidor.idregimenlaboral,
    //         strestadoproyeccion: "NO PROYECTADO",
    //         siglasregimenlaboral: informacionServidor.siglasregimenlaboral,
    //         horasextraordinarias: 0,
    //         horassuplementarias: 0,
    //         valorhorasextraordinarias: 0,
    //         valorhorassuplementarias: 0,
    //         valortotal: 0,
    //         horastotales: 0,
    //         idcontratolaboral: informacionServidor.idcontratolaboral,
    //         nombreregimenlaboral: informacionServidor.nombreregimenlaboral,
    //         idestructuraorganica: informacionServidor.idestructuraorganica,
    //         nombreestructuraorganica: informacionServidor.nombreestructuraorganica,
    //         actividadesplanificadas: [
    //         ]
    //     }

    //     return nuevoRegistroTabla;
    // }


    const OnClickAgregar = useCallback(async (seleccionado: SelectCombo | undefined | null) => {
        if (seleccionado) {

            const informacionDivision = seleccionado.value.split("|")
            const identific: string = informacionDivision[1]

            const personaExistente = informacionTabla.find((v => v.identificacion === identific));

            if (informacionTabla.length === 0 || (informacionTabla.length > 0 && personaExistente === undefined)) {

                setbuscandoinfoservidorhe(true)
                const respuestaInformacionServidor = await ObtenerInformacionServidorHE(identific);

                if (respuestaInformacionServidor.status === 200 && respuestaInformacionServidor.dataResponse) {
                    // const informacionServidor: InformacionServidoresOtrasUnidadesHEDTO = respuestaInformacionServidor.dataResponse;
                    // const nuevoRegistroTabla = CrearInformacionParaTabla(informacionServidor)

                    const informacionServidor = respuestaInformacionServidor.dataResponse;

                    if (informacionServidor.tipo && informacionServidor.tipo !== "SR") {
                        showAlert("El servidor NO puede ser proyectado porque es un directivo", false);

                    }
                    else {
                        const nuevaInfoTabla = [...informacionTabla, informacionServidor]
                        setinformacionTabla(nuevaInfoTabla)
                    }


                }
                else {
                    const messagedefault = "Ha ocurrido un inconveniente al intentar obtener información del usuario"
                    showAlert(respuestaInformacionServidor.errorMessage ?? messagedefault, false);
                }

                setbuscandoinfoservidorhe(false)

            }
            else {
                showAlert("La persona indicada ya se encuentra proyectada", false)
            }
        }
        setidentificacion("")
        setnombresSeleccionado(null)

    }, [informacionTabla])






    const mapeoParametrosHorasRegimenProyeccion: ParamsHorasMesPlanificacionHEDTO[] = props.parametrosHorasRegimenProyeccion.listadoparametroshorasregimen.map((parametros, i) => {
        return {
            idheparamhorasmes: 0,
            horasExtraordinarias: parametros.horasextraordinarias ?? 0,
            horasSuplementarias: parametros.horassuplementarias ?? 0,
            horasExtraySuple: parametros.horassuplyextr ?? 0,
            idregimenlaboral: parametros.idregimenlaboral
        }
    })








    return (
        <React.Fragment>
            <Form>
                {
                    ((props.puedeRealizarAccion !== undefined && props.puedeRealizarAccion === true) || (props.puedeRealizarAccion === undefined)) &&
                    <Row className="row-no-margin">
                        <Col md="3">
                            <FormGroup>
                                <Label>Identificacion</Label>
                                <Input
                                    value={identificacion}
                                    // disbled={nombres !== ""}
                                    type="text"
                                    name="identificacionOtraUnidad"
                                    placeholder="Ingrese identificación"
                                    autoComplete="off"
                                    onChange={(e) => ObtenerInformacionByCedula(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="5">
                            <FormGroup>
                                <Label>Apellidos/Nombres</Label>
                                <FindAsyncSelect
                                    value={nombresSeleccionado}
                                    icon="fa-caret-down"
                                    placeholder='Ingrese Apellidos/Nombres'
                                    onFind={(valor) => ObtenerInformacionByNombreApellido(valor)}
                                    onChange={(valor) => OnChangeSelectApellidoNombre(valor)}
                                    name="nombreApellidoOtraUnidad"
                                    noOptionsMessage="Ingresa un apellido o nombre"

                                />
                            </FormGroup>
                        </Col>
                        <Col md="3" className="d-flex align-items-end" >

                            <Button
                                className="btn-guardar"
                                onClick={() => OnClickAgregar(nombresSeleccionado)}
                                disabled={nombresSeleccionado === undefined}
                            >
                                Agregar
                            </Button>


                        </Col>

                    </Row>

                }

            </Form>
            <Container fluid={true}>
                <Row className="mb-2">
                    <Col className="bold" >

                        {"(Para proyectar servidores de otras unidades que realicen horas extras en su unidad)"}
                    </Col>
                </Row>
            </Container>
            {
                <TableServidoresPlanHE
                    servidoresPlan={informacionTabla}
                    recargarInformacion={props.recargarInformacion}
                    paramsHorasMesPlanificacionHE={mapeoParametrosHorasRegimenProyeccion}
                    novedadesServidores={props.novedadesServidores}
                    estadoPlanificacion={props.estadoProyeccion}
                    mensajeNovedad={props.mensajeNovedad}
                    tipo='PR'
                    idUnidadAprueba={props.idUnidadAprueba}
                    nombreUnidadAprueba={props.nombreUnidadAprueba}


                    puedeRealizarAccion={realizarAcciones}
                    firmaryEnviar={() => ChangeToPromise(props.enviarTh)}
                    guardarParcial={props.guardarParcial}
                    solicitarReverso={props.solicitarReverso}
                    mostrarFirmaryEnviar={props.mostrarFirmaryEnviar}
                    mostrarGuardarParcial={props.mostrarGuardarParcial}
                    mostrarSolicitarReverso={props.mostrarSolicitarReverso}


                    descargarResumenExcel={props.descargarResumenExcel}
                    mostrarReporteResumenProyPlanifExcel={props.mostrarReporteResumenProyPlanifExcel}
                    gruposActividad={props.gruposActividad}
                />
            }

            <ModalCargando
                show={loadingidentificacion}
                textoCargando='Buscando información...'
                size='md'
                onClose={() => setloadingidentificacion(false)}
            />
            <ModalCargando
                show={buscandoinfoservidorhe}
                textoCargando='Buscando información...'
                size='md'
                onClose={() => setbuscandoinfoservidorhe(false)}
            />
        </React.Fragment>

    )
}
